import Image from 'next/image'
import Link from 'next/link'
import { getReadableImageUrl } from '@/lib/directus'
import { sanitizeHTML } from '@/lib/utils'

interface SecImgTextProps {
	heading?: {
		title?: string
	}
	text?: {
		text?: string
	}
	options_page: string[]
	background: string
	id_section: string
	class_section: string
	image?: {
		alt: string
		image_file: {
			image: {
				id: string
				filename_disk: string
			}
		}
	}
	button?: {
		label?: string
		href?: string
	}
}

export const fields = [
	// headings
	'heading.title',

	// text
	'text.text',

	'id_section',
	'class_section',
	'options_page',
	'background',

	// image
	'image.alt',
	'image.image_file.image.id',
	'image.image_file.image.filename_download',

	'button.label',
	'button.href',
] as const

export default function SecImgText({ data }: { data: SecImgTextProps }) {
	if (!data) return null

	const hideLogo = data?.options_page?.includes('hide_logo_h')
	const isReversed = data?.options_page?.includes('flex-row-reverse')

	return (
		<section
			id={data.id_section || 'whatis'}
			className={`SecImgText w-full bg-white py-16 ${data.class_section || ''}`}
			{...(data.background && {
				style: { backgroundColor: data.background },
			})}
		>
			<div className='container'>
				<div
					className={`flex flex-col lg:flex-row gap-12 ${
						isReversed ? 'lg:flex-row-reverse' : ''
					}`}
				>
					{/* Image Column */}
					<div className='w-full lg:w-[50%]'>
						<div className='relative aspect-[808/711] w-full overflow-hidden rounded-lg lg:h-full'>
							{data?.image?.image_file?.image?.id ? (
								<Image
									src={getReadableImageUrl(
										data.image.image_file.image.id,
										data.image.image_file.image.filename_disk || ''
									)}
									alt={data.image?.alt || ''}
									fill
									className='object-cover object-center'
									priority
								/>
							) : null}
						</div>
					</div>

					{/* Content Column */}
					<div className='w-full lg:w-[50%] flex flex-col justify-center relative gap-8 xl:gap-16'>
						{/* Logo */}

						{!hideLogo && (
							<div className='relative w-16 md:w-20 h-16 md:h-20 max-sm:absolute max-sm:top-[-135px] max-sm:right-[20px]'>
								<Image
									src='/images/logo_h.svg'
									alt='Harmon Logo'
									fill
									sizes='5rem'
									className='object-contain object-center'
								/>
							</div>
						)}

						{/* Title */}
						{data?.heading?.title && <h2>{data.heading.title}</h2>}

						{/* Description */}
						<div
							className='flex flex-col gap-8'
							dangerouslySetInnerHTML={sanitizeHTML(data?.text?.text || '')}
						/>

						{data?.button?.label && (
							<Link
								href={data.button?.href || '/'}
								className='btn'
								onClick={e => {
									if (data.button?.href) {
										e.preventDefault()
										window.location.href = data.button.href
									}
								}}
							>
								{data.button.label}
							</Link>
						)}
					</div>
				</div>
			</div>
		</section>
	)
}
